import React from 'react';
import { icons, colors } from '../../shared/constants';

type CopyPublicationProps = {
  shown: boolean;
  setShown: React.Dispatch<React.SetStateAction<boolean>>;
  handle: string | undefined;
  dark?: boolean;
};

const CopyPublication: React.FC<CopyPublicationProps> = (
  props
): JSX.Element => {
  const CloseMenu = () => {
    props.setShown(false);
  };

  const darkOptionsAndColors = {
    background: props.dark
      ? colors.primaryTextColor
      : colors.primaryBackgroundColor,
    color: props.dark ? colors.primaryBackgroundColor : colors.primaryTextColor,
    copyIconShown: icons.COPY_BLUE,
    copyIconNotShown: props.dark ? icons.COPY_BLUE : icons.COPY,
  };

  const copyLinkToPublication = () => {
    navigator.clipboard.writeText(
      `${window.location.origin}/publication/${props.handle}`
    );
    setTimeout(() => {
      CloseMenu();
    }, 2000);
  };

  return (
    <div className='meatball-menu'>
      <img
        onClick={() => {
          props.setShown(!props.shown), copyLinkToPublication();
        }}
        src={
          props.shown
            ? darkOptionsAndColors.copyIconShown
            : darkOptionsAndColors.copyIconNotShown
        }
        alt='copy-article-menu'
        style={{ cursor: 'pointer' }}
      />

      <div
        className='left-drop-down-content'
        style={
          props.shown
            ? {
                height: 82,
                boxShadow: '0px 2px 10px 5px rgba(117, 117, 117, 0.08)',
                background: props.dark ? darkOptionsAndColors.background : '',
              }
            : { height: 0, background: 'transparent' }
        }
      >
        <ul style={props.shown ? {} : { display: 'none' }}>
          <div onClick={copyLinkToPublication}>
            <a>
              <li style={{ cursor: 'hand', color: darkOptionsAndColors.color }}>
                Link copied!
              </li>
            </a>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default CopyPublication;
